import React from 'react';
import Label from './label';
import { storyblokEditable } from 'gatsby-source-storyblok';
import TownCentreIcon from '../atoms/icons/towncentre';
import SkiBusIcon from '../atoms/icons/skibus';
import SkiliftIcon from '../atoms/icons/skilift';
import PisteIcon from '../atoms/icons/piste';
import { useTranslation } from 'react-i18next';
import Mountain from '../atoms/icons/mountain';
import CrossCountry from '../atoms/icons/crosscountry';
import Skier from '../atoms/icons/skier';
import HikingLevel from '../atoms/icons/hiker';
import VerticalDropIcon from '../atoms/icons/vertical';

const LabelGroup = ({ blok }) => {
  const isTable = true;
  const { t } = useTranslation('labels');

  if (isTable) {
    const types = {
      'city-center': <TownCentreIcon />,
      'ski-bus': <SkiBusIcon />,
      'transfer-time': <SkiBusIcon />,
      'ski-lifts': <SkiliftIcon />,
      'black-runs': <PisteIcon />,
      'red-runs': <PisteIcon fill="#FF5412" />,
      'blue-runs': <PisteIcon fill="#668EDC" />,
      peak: <Mountain />,
      vertical: <VerticalDropIcon />,
      'cross-country-trails': <CrossCountry />,
      'piste-length': <Skier />,
      'hiking-level-1': <HikingLevel level={1} />,
      'hiking-level-2': <HikingLevel level={2} />,
      'hiking-level-3': <HikingLevel level={3} />,
      'hiking-level-4': <HikingLevel level={4} />,
    };

    return (
      <div
        className={`w-full sm:w-1/2 pt-0 sm:pt-4 md:pt-0 md:w-full xl:pt-4 xl:w-1/2 px-4 mx-auto label-group`}
        key={blok._uid}
        {...storyblokEditable(blok)}
      >
        {' '}
        {blok.labels.map((label) => {
          return (
            <LabelCell
              icon={types[label.type] || <TownCentreIcon />}
              key={label._uid}
              description={t(label.type)}
              value={label.value}
              type={label.type}
            />
          );
        })}
      </div>
    );
  } else {
    return (
      <ul
        className={`flex ${
          blok.columns ? 'flex-row flex-wrap ' : 'items-center flex-nowrap'
        } text-xs mr-0`}
        key={blok._uid}
        {...storyblokEditable(blok)}
      >
        {blok.labels.map((label) => (
          <Label blok={label} alignColumns={blok.columns} key={label._uid} />
        ))}
      </ul>
    );
  }
};

const LabelCell = ({ icon, description, value, id, type }) => {
  const { t } = useTranslation('labels');
  return (
    <div className="py-2 px-2" key={id}>
      <div className="w-full flex justify-between items-center">
        <div className="w-full flex flex-nowrap items-start">
          <div className="flex justify-center items-center w-5 h-5">
            <span className="pr-2">{icon}</span>
          </div>
          <div className="w-full flex flex-wrap justify-between">
            <span className="pr-2 text-xs">{description}</span>

            <span className="font-bold whitespace-nowrap text-xs">
              {t(`${type}-value`, { value: value })}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LabelGroup;
